import React, { Component } from 'react';
import Meta from 'components/meta';
import Contact from 'components/contact';
import { ProjectPanel } from 'components/project';
import Wrapper from 'components/wrapper';
import TweenMax from 'gsap';
import { projects } from 'data/projects.json';
import styles from './styles.module.css';

export default class Work extends Component {
  componentDidMount(prevProps, prevState) {
    TweenMax.set(this.constactSwip, { y: 400 });
    TweenMax.fromTo(this.constactSwip, 3, { y: 400 }, { y: 0 });
  }

  render() {
    return (
      <div>
        <Meta
          title="Application Mobile"
          description="Applications Mobile en React-Native par Youcef EL KAMEL"
        />

        {projects.map((project, i) => {
          if (i === 2) {
            return [
              <h1 className={styles.limitUnavailable}>
                👇🏼 Ci-dessous, les applications mobiles plus disponible sur
                l'AppleStore et le GooglePlay 📱
              </h1>,
              <ProjectPanel project={project} key={project.slug} id={i} />,
            ];
          }
          return <ProjectPanel project={project} key={project.slug} id={i} />;
        })}

        <div ref={c => (this.constactSwip = c)} className={styles.contact}>
          <Wrapper>
            <Contact title="Ton appli ici ?" />
          </Wrapper>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./work/index.jsx